



















































































































































































import { Vue, Component } from 'vue-property-decorator';

import { fetchConfigAutorizaciones } from './fetchConfigAutorizaciones';
import { LoadingService } from '@/services/loadingService';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';

import { campos } from '@/pantallas/Conecta/ConfigAutorizaciones/camposConfigAutorizaciones';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { Funcionalidades } from '@/config/funcionalidades';
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ValueFormatterParams,
  GetQuickFilterTextParams,
  RowNode,
} from 'ag-grid-community';

import { PasosCrud } from '@/reusable/Mantenedor/mantenedorUtils';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import NavegacionModalCrud from '@/reusable/Mantenedor/NavegacionModalCrud.vue';
import CrudStepperHeader from '@/reusable/Mantenedor/CrudStepperHeader.vue';
import CrudStepperItems from '@/reusable/Mantenedor/CrudStepperItems.vue';
import CrudStepperContent from '@/reusable/Mantenedor/CrudStepperContent.vue';

import { actionsEvent } from '@/setup';
import CabeceraModalCreacion from './CabeceraModalCreacion.vue';
import ModalVerHistorial from './ModalVerHistorial.vue';
import CabeceraModalEdicion from './CabeceraModalEdicion.vue';
import CabeceraModalVisualizacion from './CabeceraModalVisualizacion.vue';
import { utils, writeFileXLSX } from 'xlsx';

import ComponenteForm from './ComponenteForm.vue';

@Component({
  components: {
    DatePicker,
    MantenedorGridSinCodigo,
    ModalMantenedor,
    CabeceraModalCreacion,
    CabeceraModalEdicion,
    CabeceraModalVisualizacion,
    CrudStepperItems,
    CrudStepperContent,
    NavegacionModalCrud,
    CrudStepperHeader,
    ComponenteForm,
    ModalVerHistorial,
  },
})
export default class ConfigAutorizaciones extends Vue {
  constructor() {
    super();
    actionsEvent.onVerDetalle(this.handleVer);
    actionsEvent.onEditar(this.handleEditar);
    actionsEvent.onVerHistorico(this.handleHistorialClick);
  }
  filtrobusquedagrilla: string = '';
  handleSearch() {
    this.gridApi.setQuickFilter(this.filtrobusquedagrilla);
    this.gridApi.setDomLayout('autoHeight');
  }
  estadoSelected: string = '';
  numeroconfig: any;
  mostrarModalHistorial: boolean = false;
  handleHistorialClick(params: any) {
    this.numeroconfig = params.data.numeroconfig;
    this.mostrarModalHistorial = true;
  }
  info: any = [];
  infoVisualizacion: any = [];
  infoEdicion: any = [];
  SinFechaFin: boolean = false;
  usuario: any = '';
  operacion: any = '';
  /* filtroFechaInicio = moment();
  filtroFechaFin = moment().add(1, 'year'); */

  infoGrilla: any = [];
  busqueda = '';
  operacionesOptions: any = [];
  usuariosOptions: any = [];

  objetoAlta: any = {};
  objetoEdicion: any = {};

  loadingService = new LoadingService();
  $snotify: any;

  /// MODAL CREACION ///
  readonly pasosCrear: PasosCrud = {
    configuracion: {
      accion: '',
      visible: true,
      step: 1,
      title: 'Crear Configuración de Autorización',
      icon: 'info',
      formState: {
        entity: null,
        validator: null,
        isDirty: false,
      },
      codigoSubAccion: 40,
      codigoAccionPadre: CodigoAccion.Crear,
    },
  };

  /// MODAL EDICION ///
  readonly pasosEditar: PasosCrud = {
    configuracion: {
      accion: '',
      visible: true,
      step: 1,
      title: 'Editar Configuración de Autorización',
      icon: 'info',
      formState: {
        entity: null,
        validator: null,
        isDirty: false,
      },
      codigoSubAccion: 40,
      codigoAccionPadre: CodigoAccion.Editar,
    },
  };

  /// MODAL VISUALIZACION ///
  readonly pasosVisualizar: PasosCrud = {
    configuracion: {
      accion: '',
      visible: true,
      step: 1,
      title: 'Ver Configuración de Autorización',
      icon: 'info',
      formState: {
        entity: null,
        validator: null,
        isDirty: false,
      },
      codigoSubAccion: 40,
      codigoAccionPadre: CodigoAccion.Editar,
    },
  };

  /// CABECERA MODAL CREAR ///
  permitirGuardCrear = false;
  abrirModalCrear = false;
  pasoActivoIndexCrear = 1;
  abrirModalEditar = false;
  pasoActivoIndexEditar = 1;
  abrirModalVer = false;
  pasoActivoIndexVer = 1;

  /// CABECERA MODAL EDITAR ///
  permitirGuardEditar = false;

  beforeMount() {
    this.getCombos();
  }

  objsParaAlta(obj: any) {
    this.objetoAlta = obj;
    if (
      this.objetoAlta.usuarioSeleccionado &&
      this.objetoAlta.operacion &&
      this.objetoAlta.numeroOrden
    )
      this.permitirGuardCrear = true;
  }

  objsParaEdicion(obj: any) {
    this.objetoEdicion = obj;
    this.permitirGuardEditar = true;
  }

  exportarExcel() {
    let informacionOrdenada = this.info.map((e: any) => {
      return {
        'Número de Configuración': e.numeroconfig,
        Usuario: e.usuariocompleto,
        'Número de Orden': e.numeroorden,
        Operación: e.configdescripcion,
        Observación: e.autoobserva,
        Estado: e.estado,
      };
    });
    const ws = utils.json_to_sheet(informacionOrdenada);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Autorizaciones');
    writeFileXLSX(wb, 'Autorizaciones.xlsx');
    this.$snotify.success('Excel Exportado Con Éxito', 3000);
  }

  guardarAlta() {
    this.loadingService.showLoading(undefined, 'guardarAlta');
    return fetchConfigAutorizaciones(
      'altaConfigAutorizaciones',
      this.objetoAlta
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1')
          this.$snotify.success(data.data.MENSAJE_RESPUESTA, 3000);
        else this.$snotify.error(data.data.MENSAJE_RESPUESTA, 3000);
      })
      .catch((err: any) => console.error(err))
      .finally(() => {
        this.cerrarModalCrear();
        this.getCombos(); // ???
        this.loadingService.hideLoading('guardarAlta');
      });
  }

  guardarEdicion() {
    //console.log(moment(this.infoEdicion[0].autofecha_fin)==moment(this.objetoEdicion.fechaFin))
    //console.log(this.infoEdicion[0].autofecha_fin==this.objetoEdicion.fechaFin._i)
    //console.log(this.infoEdicion[0].autofecha_inicio==this.objetoEdicion.fechaInicio._i)
    this.loadingService.showLoading(undefined, 'guardarEdicion');
    return fetchConfigAutorizaciones(
      'edicionConfigAutorizaciones',
      this.objetoEdicion
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1')
          this.$snotify.success(data.data.MENSAJE_RESPUESTA, 3000);
        else this.$snotify.error(data.data.MENSAJE_RESPUESTA, 3000);
      })
      .catch((err: any) => console.error(err))
      .finally(() => {
        this.cerrarModalEditar();
        this.loadingService.hideLoading('guardarEdicion');
      });
  }

  async renderGrilla(payload: any) {
    await this.cargaGrilla(payload);
    this.gridApi.setRowData(this.info);
    this.gridApi.setDomLayout('autoHeight');
  }

  cargaGrilla(body: any) {
    this.loadingService.showLoading(undefined, 'cargaGrilla');
    return fetchConfigAutorizaciones('getConfigAutorizaciones', body)
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') this.info = data.data.data;
        else {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, 3000);
          this.info = [];
        }
      })
      .catch((err: any) => console.error(err))
      .finally(() => this.loadingService.hideLoading('cargaGrilla'));
  }

  /// TABLA ///
  gridApi: GridApi = null;
  enrichedGridOptions: GridOptions = null;
  readonly funcionalidad: Funcionalidades =
    Funcionalidades.ConfigAutorizaciones;
  readonly gridOptions: GridOptions = {
    columnDefs: campos,
    onGridReady: this.handleGridReady,
    isExternalFilterPresent: this.isExternalFilterPresent,
    doesExternalFilterPass: this.doesExternalFilterPass,
    paginationPageSize: 30,
    processCellForClipboard: ({ value }) => {
      return value instanceof moment
        ? this.formatFecha(value as moment.Moment)
        : value;
    },
  };
  handleGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    this.renderGrilla({ '': '' });
  }
  fechaValueFormatter(params: ValueFormatterParams) {
    return this.formatFecha(params.value);
  }
  fechaQuickFilterGetter(params: GetQuickFilterTextParams) {
    return this.formatFecha(params.value);
  }
  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }
  handleBusqueda(consulta: string) {
    this.busqueda = consulta.toLowerCase();
    this.gridApi.onFilterChanged();
  }
  doesExternalFilterPass(node: RowNode): boolean {
    if (this.info.length > 0 && this.busqueda.length > 0) {
      let search =
        node.data.numeroconfig.toLowerCase().includes(this.busqueda) ||
        node.data.usuariocompleto.toLowerCase().includes(this.busqueda) ||
        node.data.numeroorden.toLowerCase().includes(this.busqueda) ||
        node.data.configdescripcion.toLowerCase().includes(this.busqueda) ||
        node.data.autofecha_inicio.toLowerCase().includes(this.busqueda) ||
        node.data.autofecha_fin.toLowerCase().includes(this.busqueda) ||
        node.data.autoobserva.toLowerCase().includes(this.busqueda);
      return search;
    }
    return true;
  }
  isExternalFilterPresent(): boolean {
    return true;
  }
  /// FIN TABLA ///

  cerrarModalCrear() {
    this.renderGrilla({ '': '' });
    this.abrirModalCrear = false;
    this.pasoActivoIndexCrear = 1;
    this.permitirGuardCrear = false;
    this.infoVisualizacion = [];
    return true;
  }

  cerrarModalEditar() {
    this.renderGrilla({ '': '' });
    this.pasoActivoIndexEditar = 1;
    this.abrirModalEditar = false;
    this.permitirGuardEditar = false;
    this.infoVisualizacion = [];
    return true;
  }

  cerrarModalVer() {
    this.pasoActivoIndexVer = 1;
    this.abrirModalVer = false;
  }

  handleFilters() {
    let body = {
      filtroIdUsuario: this.usuario.idusuario || '',
      filtroIdOperacion: this.operacion.configid || '',
      estadoSelected: this.estadoSelected || '',
      SinFechaFin: this.SinFechaFin,
    };
    this.renderGrilla(body);
    return true;
  }

  clearFilters() {
    this.busqueda = '';
    this.usuario = '';
    this.operacion = '';
    this.estadoSelected = '';
    this.SinFechaFin = false;
    this.renderGrilla({ '': '' });
    return true;
  }

  handleEditar(e: any) {
    this.infoEdicion = [];
    this.infoEdicion.push(e.data);
    this.abrirModalEditar = true;
    return true;
  }

  handleVer(e: any) {
    this.infoVisualizacion = [];
    this.infoVisualizacion.push(e.data);
    this.abrirModalVer = true;
    return true;
  }

  getCombos() {
    fetchConfigAutorizaciones('getComboOperaciones', {})
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1')
          this.operacionesOptions = data.data.data;
        else this.operacionesOptions = [];
      })
      .catch((err: any) => console.error(err));

    fetchConfigAutorizaciones('getComboUsuario', {})
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1')
          this.usuariosOptions = data.data.data;
        else this.usuariosOptions = [];
      })
      .catch((err: any) => console.error(err));

    return true;
  }

  get estadoIdCrear() {
    const { entity } = this.pasosCrear.configuracion.formState;
    if (!entity) return null;
    return entity.estado;
  }

  get estadoIdEditar() {
    const { entity } = this.pasosEditar.configuracion.formState;
    if (!entity) return null;
    return entity.estado;
  }

  get estadoIdVer() {
    const { entity } = this.pasosVisualizar.configuracion.formState;
    if (!entity) return null;
    return entity.estado;
  }
}
